<template>
  <div class="workbench-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招商部</el-breadcrumb-item>
      <el-breadcrumb-item>招商主管工作台</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="float-div" v-if="isAdminOrDirector()">
      <el-button type="primary" size="small" icon="el-icon-user" @click="handleSelectEmployee">选择主管身份</el-button>
    </div>

    <el-row :gutter="20" style="margin-top: 20px;">
      <!-- 左侧主要内容区 -->
      <el-col :span="16">
        <!-- 绩效展示区 -->
        <performance class="mb-20" :employee-id="employeeId" :employee-name="employeeName" :target-type="targetType" :url="performanceUrl"></performance>

        <!-- 流量&转化率展示区 -->
        <traffic-conversion class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="trafficConversionUrl"></traffic-conversion>

        <!-- 团队组员统计 -->
        <member-statistics class="mb-20" :employee-id="employeeId" :url="memberStatisticsUrl"></member-statistics>

        <!-- 意向客户展示区 -->
        <intention-customers class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="intentionCustomersUrl" @view-wechat-history="handleViewWechatHistory"></intention-customers>
      </el-col>

      <!-- 右侧侧边栏 -->
      <el-col :span="8">

        <!-- 流量趋势 -->
        <trend class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="trendUrl"></trend>

        <!-- 来源统计 -->
        <source-statistics class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="sourceStatisticsUrl"></source-statistics>

        <!-- 签约品牌统计 -->
        <brand-statistics class="mb-20" :employee-id="employeeId" :target-type="targetType" :url="brandStatisticsUrl"></brand-statistics>

        <!-- 月排行展示区 -->
        <monthly-ranking class="mb-20"></monthly-ranking>

        <!-- 门店列表展示区 (占位) -->
        <el-card class="box-card mb-20">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-office-building text-blue" style="margin-right: 5px;"></i>门店列表</span>
          </div>
          <div style="text-align: center; color: #909399; padding: 20px;">
            暂未开发，敬请期待
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-drawer title="选择员工身份" :visible.sync="dialogVisible" direction="rtl" size="350px">
      <el-table style="margin-left: 20px;" :data="employeeList" @row-click="handleRowClick" highlight-current-row :cell-style="{padding: '10px 0'}">
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column prop="name" label="员工姓名"></el-table-column>
        <el-table-column prop="job" label="职位"></el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>
import Performance from './components/Performance'
import TrafficConversion from './components/TrafficConversion'
import MonthlyRanking from './components/MonthlyRanking'
import IntentionCustomers from './components/IntentionCustomers'
import Trend from './components/Trend'
import SourceStatistics from './components/SourceStatistics'
import BrandStatistics from './components/BrandStatistics'
import MemberStatistics from './components/MemberStatistics'

export default {
  name: 'ZhaoshangZhuanyuanWorkbench',
  components: {
    Performance,
    TrafficConversion,
    MonthlyRanking,
    IntentionCustomers,
    Trend,
    SourceStatistics,
    BrandStatistics,
    MemberStatistics
  },
  data () {
    return {
      // 账号信息
      accountInfo: {
        level: null,
        employeeId: '',
        employeeName: '',
        department: '',
        job: ''
      },
      employeeId: '', // 用于传递的员工id
      employeeName: '', // 用于传递的员工姓名
      employeeList: [], // 员工列表

      dialogVisible: false, // 员工选择弹窗是否显示

      targetType: 'group',
      performanceUrl: 'zhaoshang/zhuguan/performance',
      trafficConversionUrl: 'zhaoshang/zhuguan/trafficConversion',
      intentionCustomersUrl: 'zhaoshang/zhuguan/intentionCustomers',
      trendUrl: 'zhaoshang/zhuguan/trend',
      sourceStatisticsUrl: 'zhaoshang/zhuguan/sourceStatistics',
      brandStatisticsUrl: 'zhaoshang/zhuguan/brandStatistics',
      memberStatisticsUrl: 'zhaoshang/zhuguan/memberStatistics'
    }
  },
  created () {
    this.getAccountInfo()
  },
  methods: {
    // 获取账号信息
    getAccountInfo () {
      this.accountInfo.level = window.sessionStorage.getItem('level')
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId')
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName')
      this.accountInfo.department = window.sessionStorage.getItem('department')
      this.accountInfo.job = window.sessionStorage.getItem('job')

      if (this.isAdminOrDirector()) {
        this.$message.warning('请先选择一个主管身份，才能查看员工工作台数据')
      } else {
        this.employeeId = this.accountInfo.employeeId
        this.employeeName = this.accountInfo.employeeName
      }
    },

    // 判断是否为管理员或者招商总监
    isAdminOrDirector () {
      return this.accountInfo.level <= 1 || this.accountInfo.job === '总监'
    },

    // 获取员工列表
    async getEmployeeList () {
      const { data: res } = await this.$http.get('zhaoshang/customer/employees')

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.employeeList = res.data.filter(item => item.job !== '总监' && item.job !== '员工') || []
    },

    // 点击选择员工身份
    async handleSelectEmployee () {
      await this.getEmployeeList()
      this.dialogVisible = true
    },

    handleRowClick (row) {
      this.employeeId = row._id
      this.employeeName = row.name
      this.dialogVisible = false
    },
    handleViewWechatHistory (row) {
      this.$alert('微信聊天记录功能正在开发中，敬请期待', '提示', {
        confirmButtonText: '确定',
        type: 'info'
      })
    }
  }
}
</script>

<style scoped>
.text-blue { color: #409EFF; }
.mb-20 {
  margin-bottom: 20px;
}
.float-div {
  position: absolute;
  top: 10px;
  right: 30px;
}
::v-deep .el-table__body tr.current-row > td {
  background-color: #e6f7ff !important;
  color: #1890ff !important;
  font-weight: bold;
}
::v-deep .el-table__body tr:hover > td {
  background-color: #e6f7ff !important;
  cursor: pointer;
}
::v-deep .el-table__body tr.current-row:hover > td {
  background-color: #bae7ff !important;
  cursor: pointer;
}
</style>
